export default "__VITE_ASSET__B8JveT2R__"